<script setup lang="ts">
import type { Dictionary } from '@autobid/strapi-integration/typescript/webapi/Dictionary'
import SearchFormSeat from './SearchFormSeat.vue'

defineProps<Props>()

const labelCel = ref<HTMLTableCellElement>()

interface Props {
  group: Dictionary[]
  label: string
}
</script>

<template>
  <tr class="h-16 border border-transparent border-y-slate-400">
    <td
      ref="labelCel"
      class="sticky left-0 border-y-slate-400 bg-gray-100 px-2 md:px-0"
    >
      {{ label }}
      <div
        class="absolute right-0 top-0 h-full w-[1px] bg-slate-400 md:hidden"
        :style="{ height: `${labelCel?.clientHeight}px` }"
      />
    </td>
    <td
      v-for="item in group"
      :key="item.structureId"
      class="text-center md:text-left"
    >
      <SearchFormSeat :item="item" />
    </td>
  </tr>
</template>
